import api from "@/services/api";

const { get, post, put, delete: del } = api.getPrefixedMethods("users");

export default {
  listUsers() {
    return get("");
  },
  listTeammates() {
    return get("teammates");
  },
  inviteUser(email) {
    return post("invite", { email });
  },
  revokeInvite(pk) {
    return del(`${pk}`);
  },
  getUserActionNeeded(pk) {
    return get(`${pk}/action-needed`);
  },
  updateUserActionNeeded(pk, scope, statuses) {
    return put(`${pk}/action-needed`, { scope, statuses });
  },
  deleteUser(pk) {
    return del(`${pk}`);
  },
};
